import { useQuery } from '@apollo/client';
import { CITRIN_GET_SETTINGS, GetSettingsRequest, GetSettingsResponse } from '..';
import { SettingQueryFilter } from '../../shared/types';
import { useEffect, useRef, useState } from 'react';
import { debounce } from 'lodash';

export const useGetSettingsQuery = (request: SettingQueryFilter, debounceTime?: number) => {
    const [internalRequest, setInternalRequest] = useState(() => request);
    const debounced = useRef(
        debounce(
            (newRequest: SettingQueryFilter) => {
                setInternalRequest(newRequest);
            },
            debounceTime ?? 100,
            { leading: false, trailing: true }
        )
    ).current;
    useEffect(() => {
        return debounced(request);
    }, [request]);

    const { data, previousData, ...rest } = useQuery<GetSettingsResponse, GetSettingsRequest>(CITRIN_GET_SETTINGS, {
        variables: { request: internalRequest },
        // fetchPolicy: 'cache-and-network',
        // onCompleted: (data) => console.log('[MGT] Setting', data),
    });

    return { ...rest, previousData: previousData?.CITRIN_MGT_getSettings, data: data?.CITRIN_MGT_getSettings ?? [] };
};
